<div class="quote-confirmation" *ngIf="code || code == '' else loading">
    <div class='quote-confirmation-img'>
        <!-- <img src=''> -->
    </div>
    <div class="quote-confirmation-heading">
        {{ "quoteConfirmation.successfullySubmit" | cxTranslate }}
    </div>
    <div class="quote-confirmation-heading">
        {{ "quoteConfirmation.quoteNo" | cxTranslate }} : {{code}} 
    </div> 
    <div class='quote-confirmation-content'>
        <div>{{ "quoteConfirmation.recieveEmail" | cxTranslate }} {{notificationEmail}}.</div>
        <div>{{ "quoteConfirmation.downloadQuote" | cxTranslate }}</div>
    </div>
    <button class="vs-primary-btn quote-confitmation-button" (click)='downloadPDF()'>
        <i class="material-icons-outlined">save_alt</i> {{ "quoteConfirmation.downLoadPDF" | cxTranslate }}
    </button>
    <div class="quote-confirmation-message">
        {{ "quoteConfirmation.needHelp" | cxTranslate }}
    </div>
    <div class="quote-confirmation-message">
        {{ "quoteConfirmation.please" | cxTranslate }} <a [routerLink]="['/contactus']" [queryParams]="{page: 'quote-confirmation'}" class="green">{{ "quoteConfirmation.contactUs" | cxTranslate }}</a> {{ "quoteConfirmation.viewDetails" | cxTranslate }}
    </div>
</div>

<ng-template #loading>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </ng-template>
  